import { useEffect as useEffect } from 'react';
import {
  invokechk3lkgbyxfd as invoke,
  invoke1ef51ay3uv4ui as invoke_0,
} from './raw/EffectHook.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useEffect_0(dependencies, effect) {
  invoke(useEffect, effect, dependencies);
}
function useEffectOnce(effect) {
  var tmp = useEffect;
  // Inline function 'kotlin.emptyArray' call
  var tmp$ret$0 = [];
  invoke(tmp, effect, tmp$ret$0);
}
function useEffect_1(effect) {
  invoke_0(useEffect, effect);
}
//region block: exports
export {
  useEffectOnce as useEffectOnce3v2sm1lvkf783,
  useEffect_0 as useEffect2qxfqxq43a03l,
  useEffect_1 as useEffect3flx4wscmo2hh,
};
//endregion

//# sourceMappingURL=useEffect.mjs.map
